import { render, staticRenderFns } from "./tokuten.vue?vue&type=template&id=b6902914&"
import script from "./tokuten.vue?vue&type=script&lang=js&"
export * from "./tokuten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports